import { useMemo, useState } from 'react';
import styled from 'styled-components';

import { errorHandler } from '~/components/casino-shared/explore/utilities/error-handler';
import { EnhancedGame } from '~/components/casino-shared/types';

import { getSmallestSrcFromSrcSet } from '~/components/utilities/image-format';

const VisibilityWrapper = styled.div<{ visible: boolean }>`
	display: inline-block;
	visibility: ${props => (props.visible ? 'visible' : 'hidden')};
	width: ${props => (props.visible ? '100%' : '0px')};
	height: ${props => (props.visible ? '100%' : '0px')};
`;

const MediaWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`;

const MediaContainer = styled.div`
	height: 204px;
	border-radius: 12px;
	box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.3);
	padding-top: 4px;

	img,
	video {
		border-radius: 12px;
	}
`;

type Props = {
	inGameSrcSet: string | null | undefined;
	game: EnhancedGame;
};

export const ImageComponent = ({ game, inGameSrcSet }: Props) => {
	const [SVGLoaded, setSVGLoaded] = useState(false);

	const SVGComponent = useMemo(() => {
		if (game?.otherView?.file && game?.otherView?.path && !inGameSrcSet) {
			return (
				<img
					src={`${game.otherView.path}/${game.otherView.file}`}
					alt={game?.name}
					onLoad={() => setSVGLoaded(!!game.otherView?.file && !!game.otherView.path)}
					loading="lazy"
				/>
			);
		}
		setSVGLoaded(false);
		return null;
	}, [game.otherView?.file, game.otherView?.path, game?.name, inGameSrcSet]);

	return (
		<>
			<VisibilityWrapper visible={!SVGLoaded}>
				<img
					sizes="(min-width: 64.25em) 16.666vw, (min-width: 48em) 25vw, (min-width: 20em) 50vw"
					src={inGameSrcSet ? getSmallestSrcFromSrcSet(inGameSrcSet) : game?.imageView?.src}
					srcSet={inGameSrcSet || game?.imageView?.srcSet}
					alt={game?.name}
					onError={errorHandler}
					loading="lazy"
					data-at="game-support-image"
				/>
			</VisibilityWrapper>
			<VisibilityWrapper visible={SVGLoaded && !inGameSrcSet}>{SVGComponent}</VisibilityWrapper>
		</>
	);
};

const MediaSection = ({ game, inGameSrcSet }: Props) => {
	return (
		<MediaWrapper>
			<MediaContainer>
				<ImageComponent game={game} inGameSrcSet={inGameSrcSet} />
			</MediaContainer>
		</MediaWrapper>
	);
};

export default MediaSection;
